module.exports = __webpack_public_path__ + "img/wechat.b65f134c.jpg";